<div class="tab-container mat-typography">
  <LOSx-entity-datatable-tab
    entityType="Savings Product"
    [entityId]="entityId"
    [multiRowDatatableFlag]="multiRowDatatableFlag"
    [entityDatatable]="entityDatatable"
  >
  </LOSx-entity-datatable-tab>
</div>
